/** @format */

import styled from '@emotion/styled';

export const StyledAutocomplete = styled.div`
  position: relative;
  width: 100%;
`;
